import axios from "axios";

// Server is for BeX-Orchestrator API (Dropdown API)
export const server = process.env.REACT_APP_BEX_ORCHESTRATOR_API; // Moved to .env

/**
 * *Production Beso Orchestrator*
 */
export const httpRequest = axios.create({
  withCredentials: true,
  baseURL: server,
});

// Server 1 is for BeX-Insight API
export const server1 = process.env.REACT_APP_BEX_INSIGHT_API; // Moved to .env

/**
 * *Staging BeXO*
 */
export const httpRequest1 = axios.create({
  withCredentials: true,
  baseURL: server1,
});

// Server 2 is for Test API
export const server2 = process.env.REACT_APP_FEO_URL; // Moved to .env
console.log("FEO URL", server2);
console.log("Environment Variables", process.env);

/**
 * *Test API*
 */
export const httpRequest2 = axios.create({
  withCredentials: true,
  baseURL: server2,
});

// Server 3 is for BeX-Action API
export const server3 = process.env.REACT_APP_BEX_ACTION_API; // Moved to .env
export const httpRequest3 = axios.create({
  withCredentials: true,
  baseURL: server3,
});

export const server5 = process.env.REACT_APP_BEX_INSIGHT_API; // Using .env
export const httpRequest4 = axios.create({
  withCredentials: true,
  baseURL: server5,
});

export const server6 = process.env.REACT_APP_FEO_URL; // Moved to .env
export const httpRequest6 = axios.create({
  withCredentials: true,
  baseURL: server6,
});

// project o - main
export const serverO = process.env.REACT_APP_PROJECT_O_API; // Moved to .env
export const serverOPrefix = process.env.REACT_APP_PROJECT_O_PREFIX; // Moved to .env

/**
 * *Project O Main*
 */
export const projectOHttpClient = axios.create({
  withCredentials: true,
  baseURL: `${serverO}${serverOPrefix}`,
});

const websocketO = process.env.REACT_APP_PROJECT_O_WS; // Moved to .env
const websocketOPrefix = process.env.REACT_APP_PROJECT_O_PREFIX; // Moved to .env

/**
 * *Websocket BEX Project O*
 */
export const BEX_WEBSOCKET_URL =
  "wss://stg-bex.coolriots.ai/projecto/execute/api/v1/assistant/track_auto_assistant_ws/"; //`${websocketO}${websocketOPrefix}`;

// project o - stg
const serverOStg = process.env.REACT_APP_BEX_ACTION_API; // Moved to .env
const serverOPrefixStg = process.env.REACT_APP_PROJECT_O_PREFIX;
/**
 * *Project O Staging*
 */
export const projectOHttpClientStg = axios.create({
  withCredentials: true,
  baseURL: `${serverOStg}${serverOPrefixStg}`,
});

const websocketOStg = process.env.REACT_APP_PROJECT_O_WS;
const websocketOPrefixStg = process.env.REACT_APP_PROJECT_O_PREFIX;
export const BEX_WEBSOCKET_URL_STG = `${websocketOStg}${websocketOPrefixStg}`;

/**
 * Latest BeXO Production API: https://bex.coolriots.ai/bexo/
 */
export const server4 = process.env.REACT_APP_BEX_INSIGHT_API; // Moved to .env
export const STG_KB_BASE_URL = process.env.REACT_APP_BEX_KB_API; // Moved to .env

export const fetchTenantDetails = async () => {
  try {
    const sessionData = JSON.parse(localStorage.getItem("userSession")) || {};
    const tenantId = sessionData.tenantId;
    if (!tenantId) {
      console.error("No tenant ID found in session data.");
      return;
    }

    const tenantResponse = await axios.get(
      `${server4}/api/v1/tenants/${tenantId}`
    );
    const subOrgId = tenantResponse.data.sub_orgs?.[0];
    const subOrgIds = tenantResponse.data.sub_orgs || [];
    const tenantName = tenantResponse.data?.name || '';

    if (!subOrgId) {
      console.error("No sub-organization ID found.");
      return;
    }

    return { tenantId, tenantName, subOrgId, subOrgIds };
  } catch (error) {
    console.error("Error fetching tenant details:", error);
  }
};

export const fetchCollections = async (subOrg = false) => {
  try {
    const tenantData = await fetchTenantDetails();
    if (!tenantData) return;

    let { tenantId, subOrgId } = tenantData;
    if (subOrg) {
      subOrgId = subOrg;
    }
    const collectionsResponse = await axios.get(
      `${process.env.REACT_APP_FEO_URL}/api/collection/lists?organizationId=${tenantId}&subOrganizationId=${subOrgId}`
    );

    return collectionsResponse.data || [];
  } catch (error) {
    console.error("Error fetching document collections:", error);
    return [];
  }
};

export const fetchCollectionswithSuborg = async (subOrgId) => {
  try {
    const tenantData = await fetchTenantDetails();
    if (!tenantData) return;

    const { tenantId } = tenantData;

    const collectionsResponse = await axios.get(
      `${process.env.REACT_APP_FEO_URL}/api/collection/lists?organizationId=${tenantId}&subOrganizationId=${subOrgId}`
    );

    return collectionsResponse.data || [];
  } catch (error) {
    console.error("Error fetching document collections:", error);
    return [];
  }
};


export const listFiles = async (organizationId, subOrgId, collectionId, prefix = "") => {
  let continuation_token = null;
  let hasMoreFiles = true;
  const allFiles = [];

  try {
    while (hasMoreFiles) {
      const params = {
        org: organizationId,
        bucketId: `coll-${subOrgId}-${collectionId}`,
      };

      if (prefix) {
        params.prefix = prefix;
      }

      if (continuation_token) {
        params.continuation_token = continuation_token;
      }

      const apiUrl = `${process.env.REACT_APP_FEO_URL}/api/files/listAllDoc`;
      const response = await axios.get(apiUrl, { params });

      if (response.data?.files) {
        allFiles.push(...response.data.files);
        continuation_token = response.data.next_continuation_token || null;
        hasMoreFiles = !!continuation_token;
      } else {
        hasMoreFiles = false;
      }
    }
  } catch (error) {
    console.error("Failed to fetch documents:", error);
  }

  return allFiles;
};

export const listCosFiles = async (selectedCollection) => {
  try {
    const tenantData = await fetchTenantDetails();
    if (!tenantData || !selectedCollection) return [];

    const { tenantId, subOrgId } = tenantData;
    const collectionId = selectedCollection._id;
    const bucketId = `coll-${subOrgId}-${collectionId}`;

    const collectionsResponse = await axios.get(
      `${process.env.REACT_APP_BEX_ACTION_API}${process.env.REACT_APP_BEX_ACTION_PREFIX}`, // Moved to .env
      {
        params: {
          organizationId: tenantId,
          bucketId: bucketId,
        },
        headers: {
          "bex-api-key": process.env.REACT_APP_BEX_API_KEY, // If needed from .env
        },
        withCredentials: true,
      }
    );

    return collectionsResponse.data || [];
  } catch (error) {
    console.error("Error fetching document collections:", error);
    return [];
  }
};

/**
 * A Dynamic WebSocket client maker with event interceptors.
 * @param {string} endpoint - The specific WebSocket endpoint to connect to (e.g., "/notifications").
 * @param {Object} [options={}] - Options to configure WebSocket events.
 * @returns {WebSocket} The WebSocket instance for managing connections.
 */
export const createWebSocketClient = (
  endpoint,
  deployment = "main",
  {
    onOpen = () => console.log("WebSocket connected"),
    onMessage = (message) => console.log("Received:", message.data),
    onError = (error) => console.error("WebSocket error:", error),
    onClose = () => console.log("WebSocket closed"),
  } = {}
) => {
  //const wsURL = `${process.env.REACT_APP_PROJECT_O_WS}${endpoint}`; // Moved to .env

  const wsURL = `${BEX_WEBSOCKET_URL}${endpoint}`
  const wsClient = new WebSocket(wsURL);

  wsClient.onopen = (event) => onOpen(event, wsClient);
  wsClient.onmessage = (message) => onMessage(message);
  wsClient.onerror = (error) => onError(error);
  wsClient.onclose = (event) => onClose(event);

  wsClient.sendMessage = (data) => {
    if (wsClient.readyState === WebSocket.OPEN) {
      wsClient.send(data);
    } else {
      console.warn("WebSocket is not open. Unable to send message.");
    }
  };

  return wsClient;
};
